import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { get } from '../apiClient'
import {
  extraServiceReservationsResponseSchema,
  ExtraServiceReservationsResponse,
} from '../../../common/validations/extraServiceReservationSchema'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

const params = (contractUuid: string) => {
  const path = API_ENDPOINTS.EXTRA_SERVICE_RESERVATIONS.replace(
    ':contractUuid',
    contractUuid
  )

  return {
    queryKey: ['extra-service-reservations', contractUuid],
    queryFn: async () => {
      return get(path, extraServiceReservationsResponseSchema)
    },
  }
}

export const useAPIGetExtraServiceReservations = (contractUuid: string) => {
  return useQuery(params(contractUuid))
}

export const useAPIGetExtraServiceReservationsSuspense = (
  contractUuid: string
) => {
  return useSuspenseQuery<ExtraServiceReservationsResponse>(
    params(contractUuid)
  )
}
